import api from '../api';

import { ParamsDataUserAccountPassword } from 'utils/typeServices';

type ParamsResponse = {
    Data: ParamsDataUserAccountPassword;
}

export const PostGetContacts = async ({ body }: { body: string }) => {
    const bodyJsonContacts = JSON.stringify({ login: "", document: body });

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Cliente/GetContacts', bodyJsonContacts);

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}